// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__GoToNextSong from "./goToNextSong.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";
import * as StoreFx__SaveCurrentTime from "./saveCurrentTime.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const abortController = new AbortController();
    const signal = abortController.signal;
    const listenerOptions = {
      signal: signal
    };
    const addEventListener = function (listener) {
      StoreFx__PlayerContext.audio.addEventListener(listener.NAME, listener.VAL, listenerOptions);
    };
    addEventListener({
      NAME: "ended",
      VAL: (function (param) {
        Fx.runAsync(StoreFx__GoToNextSong.make(undefined), {
          store: store
        }).then(function (result) {
          return Promise.resolve(Stdlib__Result.get_ok(result));
        });
      })
    });
    addEventListener({
      NAME: "emptied",
      VAL: (function (param) {
        store.setState(function (prevState) {
          const init = prevState.player;
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: {
              buffered: [],
              currentSongId: init.currentSongId,
              currentTime: 0.0,
              duration: undefined,
              muted: prevState.player.muted,
              paused: true,
              queuedSongIds: init.queuedSongIds,
              replayGainOptions: init.replayGainOptions,
              volume: prevState.player.volume
            },
            songs: prevState.songs
          };
        });
      })
    });
    addEventListener({
      NAME: "durationchange",
      VAL: (function (param) {
        store.setState(function (prevState) {
          const init = prevState.player;
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: {
              buffered: init.buffered,
              currentSongId: init.currentSongId,
              currentTime: init.currentTime,
              duration: Number.isFinite(StoreFx__PlayerContext.audio.duration) ? Stdlib__Option.some(StoreFx__PlayerContext.audio.duration) : undefined,
              muted: init.muted,
              paused: init.paused,
              queuedSongIds: init.queuedSongIds,
              replayGainOptions: init.replayGainOptions,
              volume: init.volume
            },
            songs: prevState.songs
          };
        });
      })
    });
    addEventListener({
      NAME: "pause",
      VAL: (function (param) {
        store.setState(function (prevState) {
          const init = prevState.player;
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: {
              buffered: init.buffered,
              currentSongId: init.currentSongId,
              currentTime: init.currentTime,
              duration: init.duration,
              muted: init.muted,
              paused: true,
              queuedSongIds: init.queuedSongIds,
              replayGainOptions: init.replayGainOptions,
              volume: init.volume
            },
            songs: prevState.songs
          };
        });
      })
    });
    addEventListener({
      NAME: "play",
      VAL: (function (param) {
        store.setState(function (prevState) {
          const init = prevState.player;
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: {
              buffered: init.buffered,
              currentSongId: init.currentSongId,
              currentTime: init.currentTime,
              duration: init.duration,
              muted: init.muted,
              paused: false,
              queuedSongIds: init.queuedSongIds,
              replayGainOptions: init.replayGainOptions,
              volume: init.volume
            },
            songs: prevState.songs
          };
        });
      })
    });
    const updateCurrentTimeRaf = {
      contents: undefined
    };
    addEventListener({
      NAME: "timeupdate",
      VAL: (function (param) {
        Stdlib__Option.iter((function (prim) {
          cancelAnimationFrame(prim);
        }), updateCurrentTimeRaf.contents);
        updateCurrentTimeRaf.contents = Caml_option.some(requestAnimationFrame(function (param) {
          updateCurrentTimeRaf.contents = undefined;
          store.setState(function (prevState) {
            const init = prevState.player;
            return {
              albums: prevState.albums,
              artists: prevState.artists,
              auth: prevState.auth,
              player: {
                buffered: init.buffered,
                currentSongId: init.currentSongId,
                currentTime: StoreFx__PlayerContext.audio.currentTime,
                duration: init.duration,
                muted: init.muted,
                paused: init.paused,
                queuedSongIds: init.queuedSongIds,
                replayGainOptions: init.replayGainOptions,
                volume: init.volume
              },
              songs: prevState.songs
            };
          });
        }));
        Curry._1(StoreFx__SaveCurrentTime.make, store);
      })
    });
    store.setState(function (prevState) {
      const init = prevState.player;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: prevState.auth,
        player: {
          buffered: init.buffered,
          currentSongId: init.currentSongId,
          currentTime: StoreFx__PlayerContext.audio.currentTime,
          duration: Number.isFinite(StoreFx__PlayerContext.audio.duration) ? StoreFx__PlayerContext.audio.duration : undefined,
          muted: StoreFx__PlayerContext.audio.muted,
          paused: StoreFx__PlayerContext.audio.paused,
          queuedSongIds: init.queuedSongIds,
          replayGainOptions: init.replayGainOptions,
          volume: StoreFx__PlayerContext.audio.volume
        },
        songs: prevState.songs
      };
    });
    const interval = setInterval((function (param) {
      const src = StoreFx__PlayerContext.audio.src;
      if (src === "") {
        return;
      }
      const buffered = StoreFx__PlayerContext.audio.buffered;
      const buffered$1 = Belt__Belt_Array.init(buffered.length, (function (i) {
        return {
          end: buffered.end(i),
          start: buffered.start(i)
        };
      }));
      const match = store.getState();
      if (!ReactRouter.deepEqual(buffered$1, match.player.buffered)) {
        store.setState(function (prevState) {
          const init = prevState.player;
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: {
              buffered: buffered$1,
              currentSongId: init.currentSongId,
              currentTime: init.currentTime,
              duration: init.duration,
              muted: init.muted,
              paused: init.paused,
              queuedSongIds: init.queuedSongIds,
              replayGainOptions: init.replayGainOptions,
              volume: init.volume
            },
            songs: prevState.songs
          };
        });
        return;
      }
      
    }), 500);
    return {
      TAG: /* Ok */ 0,
      _0: (function (param) {
        clearInterval(interval);
        abortController.abort();
      })
    };
  }));
}

export {
  make,
}
/* @tanstack/react-router Not a pure module */
